import axios from 'axios';
import { base64ToObject, objectToBase64 } from '../encrypt';

const FetchApi = axios.create({
    baseURL: process.env.REACT_APP_ENDPOINT,
    headers: {
        // 'Authorization': `Bearer ${ objectToBase64(process.env.REACT_APP_APPTOKEN) }`
        'Authorization': `Bearer ${ process.env.REACT_APP_APPTOKEN }`
    }
});

FetchApi.interceptors.request.use(
    (request) => {
        // let encPayload = objectToBase64(request.data);
        let newRequest = {
            // ...request, data: encPayload
            ...request, data: request.data
        };
        return newRequest;
    },
    (error) => {
        return Promise.reject(error);
    }
);

FetchApi.interceptors.response.use(
    (response) => {
        // return base64ToObject(response.data);
        return response.data;
    },
    (error) => {
        return Promise.reject(error.response.data);
    }
);

export default FetchApi;
